export var JumpType;
(function (JumpType) {
    JumpType[JumpType["FORWARD"] = 0] = "FORWARD";
    JumpType[JumpType["BACKWARD"] = 1] = "BACKWARD";
})(JumpType || (JumpType = {}));
;
//# sourceMappingURL=JumpType.js.map